import { IFilterService } from 'angular';
import * as XLSX from 'xlsx';

import * as LogService from '../../core/services/logservice/log.service';
import { ScreenLockService } from '../../core/services/screenLockService/screenLock.service';
import * as Model from '../../models/models';
import { PaymentSearchByStatementGateway } from './paymentSearchByStatement.gateway';
import { PaymentSearchByStatementViewModel } from './paymentSearchByStatement.viewmodel';


export class PaymentSearchByStatementController {
    private paymentSearchByStatementViewModel: PaymentSearchByStatementViewModel;
    private searchCriteria: Model.PaymentSearchByStatementSearchCriteria;
    private isDataGridLoading: boolean;

    static $inject = [ '$state', '$filter', 'logService', 'paymentSearchByStatement.gateway', 'screenLockService'];

    constructor(
        private $state: ng.ui.IStateService,
        private $filter: IFilterService,
        private logger: LogService.ILogService,
        private paymentSearchByStatementGateway: PaymentSearchByStatementGateway,
        private screenLockService: ScreenLockService
    ) {
        this.searchCriteria = new Model.PaymentSearchByStatementSearchCriteria();
    }

    public export(): void {
        if(!this.paymentSearchByStatementViewModel
            || !this.paymentSearchByStatementViewModel.searchResults
            || this.paymentSearchByStatementViewModel.searchResults.length <= 0
        ){
            return;
        }

        const organizationName = this.searchCriteria.organizationName;
        const statementStartDate = this.$filter('date')(this.searchCriteria.eventTimeFromUtc, 'MM/dd/yy', 'UTC');
        const statementEndDate = this.$filter('date')(this.searchCriteria.eventTimeToUtc, 'MM/dd/yy', 'UTC');

        const wb = XLSX.utils.book_new();
            const data: Array<Array<string>> = [
                [
                    "Search Criteria"
                ],
                [
                    'Organization Name',
                    organizationName
                ],
                [
                    'Statement Start Date',
                    statementStartDate
                ],
                [
                    'Statement End Date',
                    statementEndDate
                ],
                [],
                [
                    "ORGANIZATION",
                    "AUTO",
                    "BILL DUE",
                    "PAST DUE",
                    "BILLED",
                    "PAYMENT",
                    "STATUS",
                    "REASON",
                    "TYPE"
                ],
            ];
            this.paymentSearchByStatementViewModel.searchResults.forEach(searchResult => {
                const billDue: string = this.$filter('date')(searchResult.currentDueDate, 'MM/dd/yy', 'UTC');
                const pastDueBalance: string = this.$filter('currency')(searchResult.pastDueBalance);
                const billedAndUnpaidBalance: string = this.$filter('currency')(searchResult.billedAndUnpaidBalance);
                const paymentAmount: string = this.$filter('currency')(searchResult.paymentAmount);
                const row: Array<string> = [
                    searchResult.organizationName,
                    searchResult.autoPayStatus(),
                    billDue,
                    pastDueBalance,
                    billedAndUnpaidBalance,
                    paymentAmount,
                    searchResult.decisionTypeCode,
                    searchResult.reasonCode,
                    searchResult.paymentType
                ];
                data.push(row);
            });
            var ws = XLSX.utils.aoa_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, "Payment Reconciliation");
            XLSX.writeFile(wb, "payment-reconciliation.xlsx");
    }

    public submit(): void {
        this.isDataGridLoading = true;

        // if searchResultsGrid is already loaded then clear it so the spinner does not spin on top of data
        if (typeof(this.paymentSearchByStatementViewModel) != "undefined") {
            if (typeof (this.paymentSearchByStatementViewModel.searchResults) != "undefined") {
                this.paymentSearchByStatementViewModel.searchResults = null;
           }
        }

        const paymentSearchViewModelPromise: ng.IPromise<PaymentSearchByStatementViewModel> = this.paymentSearchByStatementGateway.loadPaymentSearchByStatementViewModel(this.searchCriteria);
        paymentSearchViewModelPromise.then((viewModel: PaymentSearchByStatementViewModel) => {
            this.logger.debug("searchViewModelPromise", viewModel);
            this.paymentSearchByStatementViewModel = viewModel;
            this.isDataGridLoading = false;
        });
    }
}